import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Service Worker Registration for PWA/TWA Support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

try {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error("Critical initialization error:", error);
  // Render a fallback directly to the DOM in case React completely fails
  rootElement.innerHTML = `
    <div style="background:black;color:red;height:100vh;display:flex;align-items:center;justify-content:center;padding:20px;text-align:center;font-family:monospace;">
      <div>
        <h2 style="font-size:20px;margin-bottom:10px;">SYSTEM FAILURE</h2>
        <p>${error instanceof Error ? error.message : 'Unknown error occurred'}</p>
        <p style="color:white;font-size:12px;margin-top:20px;">Try reloading the application.</p>
      </div>
    </div>
  `;
}